import { gql } from '@apollo/client';

// ===== Types =====

export interface AddressWhitelistType {
  id: string;
  originalZipcode: string;
  originalState: string;
  originalCity: string;
  originalDistrict?: string | null;
  originalStreetAddress: string;
  originalBuilding?: string | null;
  originalFullAddress: string;
  originalAddressHash: string;
  addressId?: number | null;
  addressSource?: string | null;
  standardizedFullAddress?: string | null;
  isEnabled: boolean;
  remark?: string | null;
  creatorId: string;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface AddressWhitelistPageResponse {
  content: AddressWhitelistType[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface GetAddressWhitelistListResponse {
  addressWhitelistList: AddressWhitelistPageResponse;
}

export interface CreateAddressWhitelistInput {
  originalZipcode: string;
  originalState: string;
  originalCity: string;
  originalDistrict?: string | null;
  originalStreetAddress: string;
  originalBuilding?: string | null;
  originalFullAddress: string;
  addressId?: number | null;
  addressSource?: string | null;
  standardizedFullAddress?: string | null;
  isEnabled: boolean;
  remark?: string | null;
}

// ===== Address Validation =====

export interface AddressValidationResult {
  isValid: boolean;
  normalizedComponents?: {
    addressLine1: string;
    cityName?: string | null;
    stateAbbreviation?: string | null;
    zipcode?: string | null;
  } | null;
  entityComponents?: {
    addressLine1: string;
    addressLine2?: string
    cityName?: string | null;
    stateAbbreviation?: string | null;
    zipcode?: string | null;
    idLog?: string | null;
  } | null;
  validationReason?: string | null;
}

export interface AnalyzeAddressSimpleResponse {
  analyzeAddressSimple?: AddressValidationResult | null;
}

export const ANALYZE_ADDRESS_SIMPLE = gql`
  query WhitelistAnalyzeAddressSimple(
    $streetAddress: String!
    $unit: String
    $city: String!
    $state: String!
    $zipCode: String!
    $forceExternalApiMatch: Boolean  
  ) {
    analyzeAddressSimple(
      streetAddress: $streetAddress
      unit: $unit
      city: $city
      state: $state
      zipCode: $zipCode
      forceExternalApiMatch: $forceExternalApiMatch
    ) {
      isValid
      validationReason
      normalizedComponents {
        addressLine1
        cityName
        stateAbbreviation
        zipcode
      }
      entityComponents {
          addressLine1
          addressLine2
          cityName
          stateAbbreviation
          zipcode
          idLog
      }        
    }
  }
`;

// ===== Query =====

export const GET_ADDRESS_WHITELIST_LIST = gql`
  query GetAddressWhitelistList(
    $originalZipcode: String
    $originalState: String
    $originalCity: String
    $originalFullAddress: String
    $isEnabled: Boolean
    $page: Int!
    $size: Int!
  ) {
    addressWhitelistList(
      originalZipcode: $originalZipcode
      originalState: $originalState
      originalCity: $originalCity
      originalFullAddress: $originalFullAddress
      isEnabled: $isEnabled
      page: $page
      size: $size
    ) {
      content {
        id
        originalZipcode
        originalState
        originalCity
        originalDistrict
        originalStreetAddress
        originalBuilding
        originalFullAddress
        originalAddressHash
        addressId
        addressSource
        standardizedFullAddress
        isEnabled
        remark
        creatorId
        createdAt
        updatedAt
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

// ===== Mutations =====

export const CREATE_ADDRESS_WHITELIST = gql`
  mutation CreateAddressWhitelist($input: CreateAddressWhitelistInput!) {
    createAddressWhitelist(input: $input) {
      id
      originalFullAddress
      isEnabled
      createdAt
    }
  }
`;

export const UPDATE_ADDRESS_WHITELIST_ENABLED = gql`
  mutation UpdateAddressWhitelistEnabled($id: Long!, $isEnabled: Boolean!) {
    updateAddressWhitelistEnabled(id: $id, isEnabled: $isEnabled)
  }
`;

export const DELETE_ADDRESS_WHITELIST = gql`
  mutation DeleteAddressWhitelist($id: Long!) {
    deleteAddressWhitelist(id: $id)
  }
`;

export const BATCH_DELETE_ADDRESS_WHITELIST = gql`
  mutation BatchDeleteAddressWhitelist($ids: [Long!]!) {
    batchDeleteAddressWhitelist(ids: $ids)
  }
`;
